module.exports = __webpack_public_path__ + "static/media/The High Sparrow 2.ed1db421.jpg";